import { GenericEventsRouteProvider } from '@wix/data-tools-generic-events';
import { useShowMobileAppCard } from '../../../lib/mobile-app-status';
import { BriefSlot } from '../BriefSlot';
import { AgentsIslandBadge, useAgentsPillReady } from '../AgentsIslandBadge';
import { useChipSlotHolds } from '../chip-morph/ChipSlotContext';
import { ConnectToolsCard } from '../catch-up/ConnectToolsCard';
import { MobileAppCard } from '../catch-up/MobileAppCard';
import { GreetingDate } from './GreetingDate';
import styles from './DesktopHomeHeader.module.css';

// The desktop home header (Figma "Catch Up states" 7419:47452): the agents island sits top-LEFT with
// the greeting under it, the big date rides the top-RIGHT, and below them the brief card (~⅔) beside
// the download-the-app QR (~⅓). The island used to be pinned top-right by AppFrame's `TopBarIsland`;
// on this screen it now lives inline here (AppFrame drops it on `/` — see `pillOnTopBar`).
export function DesktopHomeHeader({ home2 = false }: { home2?: boolean }) {
  const showQr = useShowMobileAppCard();
  // Mirror MobileHomeHeader: while a minimized call owns the shared capsule (lib/chip-morph.ts) the
  // pill is not in this row, but the row must keep its height or the greeting/brief jump.
  const pillReady = useAgentsPillReady();
  const pillHere = useChipSlotHolds('pill');
  const reserving = pillReady && !pillHere;

  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <div className={styles.identity}>
          <div className={`${styles.islandRow}${reserving ? ` ${styles.islandRowReserved}` : ''}`}>
            {reserving ? null : (
              <GenericEventsRouteProvider value="agents-island">
                <AgentsIslandBadge side="left" />
              </GenericEventsRouteProvider>
            )}
          </div>
          <GreetingDate part="greeting" />
        </div>
        <GreetingDate part="date" />
      </div>
      {/* The brief card is fixed at the design's ⅔, and the ⅓ beside it belongs to whichever of the two
          offers this account has coming: the download-the-app QR if it has never had the app, else the
          connect-tools callout (Figma 15545:336847 draws the QR state; without it the callout takes
          that slot). The column is therefore never empty any more, and the brief still aligns with the
          tasks strip below it (Figma "Catch Up states" 7419:47452).

          `CatchUpSections` reads the SAME `useShowMobileAppCard` to decide whether the band carries the
          callout, so exactly one of the two places renders it — see the note there.

          Home 2 (symphonyHome2Web): the brief is the ONLY component in the row — the connect-tools
          fallback is dropped, so the ⅓ column carries the QR when there is one and is otherwise empty. */}
      <div className={`${styles.briefRow}${showQr ? ` ${styles.qrRow}` : ''}`}>
        <BriefSlot home2={home2} />
        {showQr ? <MobileAppCard bare /> : home2 ? null : <ConnectToolsCard />}
      </div>
    </div>
  );
}
